import { render } from "./detail.vue?vue&type=template&id=3c06a584"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=3c06a584&lang=css"
script.render = render

export default script